document.addEventListener("DOMContentLoaded", () => {
  const market = window.currentMarket; // "AU" or "NZ"
  if (market !== "AU" && market !== "NZ") return;

  const { pathname, search = "", hash = "" } = window.location;

  // ABSOLUTE path with leading slash
  const targetPath = "/en-au/pages/uphillsport-australia-new-zealand";

  // Normalize trailing slashes so "/x" equals "/x/"
  const normalize = (p) => p.replace(/\/+$/, "");

  // If you're already on the target (or under it), don't redirect
  const alreadyOnTarget =
    normalize(pathname) === normalize(targetPath) ||
    normalize(pathname).startsWith(normalize(targetPath) + "/");

  if (!alreadyOnTarget) {
    // Use replace() so Back doesn't return to the pre-redirect page
    window.location.replace(`${targetPath}${search}${hash}`);
  }
});